var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29704_42074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 0.234375C13.8411 0.234375 17.7656 4.15885 17.7656 9C17.7656 13.8411 13.8411 17.7656 9 17.7656C4.15885 17.7656 0.234375 13.8411 0.234375 9C0.234375 4.15885 4.15885 0.234375 9 0.234375Z",
    fill: "#F0F0F0",
    stroke: "#171717",
    strokeWidth: 0.468658
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0004 8.99978C18.0004 5.13009 15.5581 1.83121 12.1309 0.55957V17.44C15.5581 16.1683 18.0004 12.8695 18.0004 8.99978Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9.00075C0 12.8704 2.44241 16.1693 5.86958 17.441V0.560547C2.44241 1.83218 0 5.13107 0 9.00075Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29704_42074"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFr);
export default __webpack_public_path__ + "static/media/fr.6caec3b90c5a6a0617f0128c663a23b2.svg";
export { ForwardRef as ReactComponent };